import { gql } from '@apollo/client';

/** health 返回秒级时间戳，乘以 1000 得到毫秒 */
export const GET_CURRENT_SERVER_TIME_MILLIS = gql`
  query GetCurrentServerTimeMillis {
    health
  }
`;

export interface GetCurrentServerTimeMillisResponse {
  health: number;
}
